import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function RegisterScreen() {
  const [username, setUsername] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { register, error, loading, clearError } = useAuth();
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!username.trim() || !phone.trim() || !password.trim()) return;
    const success = await register(
      username.trim(),
      phone.trim(),
      password,
      displayName.trim() || undefined
    );
    if (success) {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-container">
        <h1 className="auth-title">Register</h1>
        <form onSubmit={handleRegister} className="auth-form">
          <input
            className="auth-input"
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => { setUsername(e.target.value); clearError(); }}
          />
          <input
            className="auth-input"
            type="text"
            placeholder="Display Name (optional)"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
          />
          <input
            className="auth-input"
            type="tel"
            placeholder="+ Phone number"
            value={phone}
            onChange={(e) => { setPhone(e.target.value); clearError(); }}
          />
          <div className="password-field">
            <input
              className="auth-input"
              type={showPassword ? 'text' : 'password'}
              placeholder="Password (min 4 chars)"
              value={password}
              onChange={(e) => { setPassword(e.target.value); clearError(); }}
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '🙈' : '👁️'}
            </button>
          </div>
          {error && <div className="auth-error">{error}</div>}
          <button className="auth-button" type="submit" disabled={loading}>
            {loading ? <span className="spinner" /> : 'Register'}
          </button>
        </form>
      </div>
    </div>
  );
}
